import React, { useState, useEffect } from 'react';
import { Table, Spinner, Alert, Button, Card } from 'react-bootstrap';
import axios from 'axios';
import { authHeader } from '../services/auth-header';
import { BASE_URL } from '../services/Api';
import { useLocation, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

const ProductStockDetailsValuePage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // Get all parameters from navigation state
    const {
        productId,
        fromDate,
        toDate,
        warehouseId,
        brandId,
        warehouseName,
        brandName,
        reportState
    } = location.state || {};

    const [stockData, setStockData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [productInfo, setProductInfo] = useState(null);

    useEffect(() => {
        if (!productId || !fromDate || !toDate) {
            setError('Missing required parameters');
            return;
        }

        fetchProductStockDetails();
        fetchProductBasicInfo();
    }, [productId, fromDate, toDate, warehouseId, brandId]);

    const fetchProductStockDetails = async () => {
        try {
            setLoading(true);
            setError(null);

            const params = new URLSearchParams({
                pid: productId,
                fromdate: fromDate,
                todate: toDate,
                wid: warehouseId || '',
                bid: brandId || ''
            });

            const response = await axios.get(
                `${BASE_URL}stockreport/stockreportwithdateamount?${params}`,
                { headers: authHeader() }
            );

            setStockData(response.data);
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Failed to fetch product stock details');
            console.error('Error fetching product stock details:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchProductBasicInfo = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}product/${productId}`,
                { headers: authHeader() }
            );
            setProductInfo(response.data);
        } catch (err) {
            console.error('Error fetching product info:', err);
        }
    };


    const handleGoBack = () => {
        navigate('/stock-report-value', {
            state: {
                reportState
            }
        });
    };


    const formatDate = (dateString) => {
        try {
            return format(new Date(dateString), 'dd MMM yyyy');
        } catch {
            return dateString;
        }
    };

    return (
        <div className="container mt-4">
            <Card className="mb-4">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h2 className="mb-0">
                            Stock Details Report-Value: {productInfo?.productname || 'Product'} (ID: {productId})
                        </h2>
                        <Button variant="outline-secondary" onClick={handleGoBack}>
                            Back to Report
                        </Button>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <p><strong>Date Range:</strong> {formatDate(fromDate)} to {formatDate(toDate)}</p>
                        </div>
                        <div className="col-md-4">
                            <p><strong>Warehouse:</strong> {warehouseName || 'All'}</p>
                        </div>
                        {/* <div className="col-md-4">
                            <p><strong>Brand:</strong> {brandName || 'All'}</p>
                        </div> */}
                    </div>
                </Card.Body>
            </Card>
            {error && (
                <Alert variant="danger" onClose={() => setError(null)} dismissible>
                    {error}
                </Alert>
            )}
            {loading ? (
                <div className="text-center py-4">
                    <Spinner animation="border" />
                    <p>Loading stock details...</p>
                </div>
            ) : (
                <Card>
                    <Card.Body className="p-0">
                        <div className="table-responsive">
                            <Table striped bordered hover className="mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Date</th>
                                        <th>Transaction Type</th>
                                        <th>Product Name</th>
                                        <th>Product Type</th>
                                        <th>Stock Type</th>
                                        <th>Unit of Measure (UOM)</th>
                                        <th>Opening Stock</th>
                                        <th>Inward Qty</th>
                                        <th>Outward Qty</th>
                                        <th>Closing Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stockData.length > 0 ? (
                                        stockData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{formatDate(item.tranDate)}</td>
                                                <td>{item.transactiontype}</td>
                                                <td>{item.productname}</td>
                                                <td>{item.producttype}</td>
                                                <td>{item.stocktype}</td>
                                                <td>{item.uom}</td>
                                                <td>{item.osqty}</td>
                                                <td>{item.inwardqty}</td>
                                                <td>{item.outwardqty}</td>
                                                <td>{item.closingqty}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="11" className="text-center py-4">
                                                No stock data available for the selected period
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
};
export default ProductStockDetailsValuePage;